import recordEvent from 'platform/monitoring/record-event';

import { useEffect } from 'react';

export const mapPageNames = page => {
  if (
    page.match(
      '/get-help-from-accredited-representative/appoint-rep/introduction/?',
    )
  )
    return 'appoint-representative-introduction';
  if (page.match('/get-help-from-accredited-representative/find-rep/?'))
    return 'find-representative';
  if (page.match('/get-help-from-accredited-representative/?'))
    return 'get-help-from-representative';
  return page;
};

export default ({ userHasPOAAccess, isUserLOA1, isUserLOA3 }) => {
  const pageName = mapPageNames(window.location.pathname);
  useEffect(() => {
    if (userHasPOAAccess) return;

    if (isUserLOA3) {
      recordEvent({
        event: 'api_call',
        'api-name': `fetch-rep-status-user-loa3-no-poa-access`,
        'api-status': undefined,
        'api-latency-ms': undefined,
        'error-key': undefined,
        version: pageName,
      });
    } else if (isUserLOA1) {
      recordEvent({
        event: 'api_call',
        'api-name': 'fetch-rep-status-user-loa1',
        'api-status': undefined,
        'api-latency-ms': undefined,
        'error-key': undefined,
        version: pageName,
      });
    }
  }, [userHasPOAAccess, isUserLOA1, isUserLOA3, pageName]);

  return null;
};
